export { default as macIconRegistration } from './data/macIconsRegistration';
